/* subtitle.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { element } from '../../core/elements';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _14 = "._19bvidpf{padding-left:0}";
const _13 = "._n3tdftgi{padding-bottom:8px}";
const _12 = "._u5f3idpf{padding-right:0}";
const _11 = "._ca0qidpf{padding-top:0}";
const _10 = "._18u0idpf{margin-left:0}";
const _9 = "._otyridpf{margin-bottom:0}";
const _8 = "._2hwxidpf{margin-right:0}";
const _7 = "._19pkidpf{margin-top:0}";
const _6 = "._vwz4gktf{line-height:20px}";
const _5 = "._zg8l4jg8{font-style:normal}";
const _4 = "._1wybdlk8{font-size:14px}";
const _3 = "._ect41wi2{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _2 = "._k48p1nn1{font-weight:400}";
const _ = "._syaz1k3w{color:var(--ds-text-subtle)}";
const subTitleTextStyle = null;
function Subtitle(_ref) {
  let {
    children
  } = _ref;
  if (!children) return null;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsx("h3", {
      className: ax(["_syaz1k3w _k48p1nn1 _ect41wi2 _1wybdlk8 _zg8l4jg8 _vwz4gktf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdftgi _19bvidpf"]),
      children: children
    })]
  });
}
const _Subtitle = element(Subtitle);
export { _Subtitle as Subtitle };